<div class="help-menu" data-cy="help-menu">
  <ul class="help-menu-sections">
    @if (generalSection) {
      <ng-container
        *ngTemplateOutlet="sectionItem; context: { $implicit: generalSection }"
      ></ng-container>
      <li class="help-menu-separator" role="separator"></li>
    }
    @for (s of viewSections; track s.id) {
      <ng-container
        *ngTemplateOutlet="sectionItem; context: { $implicit: s }"
      ></ng-container>
    }
  </ul>

  <div class="help-menu-pages">
    <div class="help-menu-pages-header">
      <h2>{{ label(selectedSection) }}</h2>
      <span>{{
        'common.instructions-browser.page-count'
          | translate: { count: count(selected) }
      }}</span>
    </div>
    <div class="help-menu-columns">
      @for (column of columns; track $index) {
        <ul class="help-menu-column">
          @for (group of column; track group[0].slug) {
            @for (page of group; track page.slug) {
              <li>
                <button
                  type="button"
                  class="help-menu-page"
                  [class.help-menu-subpage]="page.parent"
                  [class.help-menu-current]="page.slug === currentSlug"
                  [attr.aria-current]="
                    page.slug === currentSlug ? 'page' : null
                  "
                  (click)="pageSelected.emit(page.slug)"
                  [attr.data-cy]="'help-menu-page-' + page.slug"
                >
                  <span>{{ title(page.slug) }}</span>
                  @if (page.slug === currentSlug) {
                    <span class="help-menu-badge">{{
                      'common.instructions-browser.this-page' | translate
                    }}</span>
                  }
                </button>
              </li>
            }
          }
        </ul>
      }
    </div>
  </div>
</div>

<ng-template #sectionItem let-s>
  <li>
    <button
      type="button"
      class="help-menu-section"
      [class.help-menu-section-selected]="s.id === selected"
      (click)="select(s.id)"
      [attr.data-cy]="'help-menu-section-' + s.id"
    >
      <span>{{ label(s) }}</span>
      @if (s.id === selected) {
        <i class="pi pi-chevron-right"></i>
      } @else {
        <span class="help-menu-count">{{ count(s.id) }}</span>
      }
    </button>
  </li>
</ng-template>
